import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { ASSET_TAB } from '../../constants'
import type { ASSET_TAB_TYPE } from '../../constants'

import { StoresContext } from '../../provider/StoreProvider'

import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { Header } from '../../components/header'
import { Tab } from '../../components/tab'
import { AssetHold } from './AssetHold'
import { AssetFinish } from './AssetFinish'

export const Asset = () => {
  const { commonStore } = useContext(StoresContext)

  const [listType, setListType] = useState<ASSET_TAB_TYPE>(ASSET_TAB.HOLD)

  useEffect(() => {
    commonStore.setShowTab(false)
    setListType(ASSET_TAB.HOLD)
  }, [])

  const onSegmentChange = (value: ASSET_TAB_TYPE) => {
    setListType(value)
  }

  return (
    <Wrap>
      <Header type="SUB" title="총 보유 자산" />
      <Tab
        items={[
          { text: '보유 중', value: ASSET_TAB.HOLD },
          { text: '매각 완료', value: ASSET_TAB.FINISH },
        ]}
        onChange={onSegmentChange}
      />
      <StyledContent id="infinity-scroll-target">
        {listType === 'HOLD' && <AssetHold />}
        {listType === 'FINISH' && <AssetFinish />}
      </StyledContent>
    </Wrap>
  )
}

const StyledContent = styled(Content)`
  padding-bottom: 16px;
`
